import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { DocumentationModule } from '@/components/modules/Documentation/Documentation';
import { KYCLoanModule } from '@/components/modules/KYC/KYCLoan/KYCLoan';
import { PersonalFinanceModule } from '@/components/modules/PersonalFinance/PersonalFinance';
import { LoanDetailsOverviewModule } from '@/components/modules/ProductsDetailsOverview/LoanDetailsOverview';
import { RiskScoreModule } from '@/components/modules/Risk/RiskScore/RiskScore';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES, APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_CREDIT_LINE: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CREDIT_LINE,
  showIfAllowedProduct: ApplicationType.CREDIT_LINE,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'CREDIT_LINE_DETAIL',
      widgets: [
        { id: WIDGETS.LOAN_PARTICIPANT_SOURCE_WIDGET, roles: [...ALL_CORE_APP_ROLES], props: {} },
        {
          id: WIDGETS.LOAN_DETAIL_ACTIONS,
          roles: [
            APP_ROLES.ADMIN,
            APP_ROLES.SUPER_ADMIN,
            APP_ROLES.MERCHANT,
            APP_ROLES.CHANNEL,
            APP_ROLES.AGENT,
            APP_ROLES.CPC_BACK_OFFICE,
          ],
          props: {},
        },
        {
          id: WIDGETS.OPEN_APPLICATION,
          roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.LENDER, APP_ROLES.CPC_BACK_OFFICE],
          props: { application: ApplicationType.CREDIT_LINE },
        },
        { id: WIDGETS.CUSTOMER_SUPPORT, roles: [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN], props: {} },
        {
          id: WIDGETS.NOTIFICATIONS_WIDGET,
          roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.LENDER, APP_ROLES.CPC_BACK_OFFICE],
          props: {},
        },
        {
          id: WIDGETS.LOAN_HIGHLIGHTS,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
        },
        { id: WIDGETS.LOAN_PAGE_TITLE, roles: [...ALL_CORE_APP_ROLES], props: {}, notShownInRightMenu: true },
        {
          id: WIDGETS.LOAN_PRODUCT_TYPE_REDIRECT,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
          notShownInRightMenu: true,
        },
      ],
    },
  ],
  sections: [
    {
      textId: 'LOAN_OVERVIEW',
      module: (
        <LoanDetailsOverviewModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
    {
      textId: 'PERSONAL_INFORMATION',
      module: (
        <KYCLoanModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT_GROUP,
              // APP_USER_TYPES.MERCHANT,
              // APP_USER_TYPES.CHANNEL,
              // APP_USER_TYPES.AGENT,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.LENDER,
              APP_USER_TYPES.CPC_BACK_OFFICE,
              // APP_USER_TYPES.THIRD_PARTY_VALIDATION,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.CPC_BACK_OFFICE],
          }}
        />
      ),
    },
    {
      textId: 'PERSONAL_FINANCE',
      module: (
        <PersonalFinanceModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT_GROUP,
              // APP_USER_TYPES.MERCHANT,
              // APP_USER_TYPES.CHANNEL,
              // APP_USER_TYPES.AGENT,
              // APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.LENDER,
              APP_USER_TYPES.CPC_BACK_OFFICE,
              // APP_USER_TYPES.THIRD_PARTY_VALIDATION,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.CPC_BACK_OFFICE],
          }}
        />
      ),
    },
    {
      textId: 'RISK_SCORE',
      module: (
        <RiskScoreModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN, APP_USER_TYPES.CPC_BACK_OFFICE],
          }}
        />
      ),
    },
    {
      textId: 'DOCUMENTATION',
      module: (
        <DocumentationModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.LENDER,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.CPC_BACK_OFFICE,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.LENDER, APP_ROLES.CPC_BACK_OFFICE],
          }}
          paymentMethodType={PaymentMethodType.CREDIT_LINE}
        />
      ),
    },
    {
      textId: 'DOCUMENTATION',
      module: (
        <DocumentationModule
          permissions={{
            view: [APP_USER_TYPES.MERCHANT, APP_USER_TYPES.CHANNEL, APP_USER_TYPES.AGENT],
            edit: [APP_ROLES.MERCHANT, APP_ROLES.CHANNEL, APP_ROLES.AGENT],
          }}
          paymentMethodType={PaymentMethodType.CREDIT_LINE}
        />
      ),
    },
    // // {
    // //   textId: 'FRAUD',
    // //   schemesByRoles: [
    // //     {
    // //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MERCHANT, ROLES.CHANNEL, ROLES.LENDER],
    // //       modules: [<Fraud />],
    // //     },
    // //   ],
    // // },
  ],
};
